import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../Themes/Colors';

const useStyles = makeStyles({
  flexBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loader: {
    color: colors.blue,
  },
});

const Loader = () => {
  const classes = useStyles();

  return (
    <div className={classes.flexBox}>
      <CircularProgress classes={{ root: classes.loader }} />
    </div>
  );
};

export default Loader;
